// extracted by mini-css-extract-plugin
module.exports = {"container":"SoundControl_container__1o_B1","volumeIcon":"SoundControl_volumeIcon__1M8lf","progress":"SoundControl_progress__1V1ju"};